import React from 'react';

const DescriptionItem = props => (
  <div dangerouslySetInnerHTML={{ __html: props.content }} />
);

export default DescriptionItem;
